import request from '@/utils/zsm-requets'
const goodPick = '/zsm/api/goodPick/' // 商品集
/*
* 列表
* frontId  前端id
* platformDict  平台
* shareTitle  分享标题
* sourceDict  类型
 */

export function listDataGoodPick(params) {
  return request({
    url: goodPick + 'listData',
    method: 'post',
    params
  })
}
/*
* 查看
* frontId  前端id
* platformDict  平台
* shareTitle  分享标题
* sourceDict  类型
 */

export function getGoodPick(params) {
  return request({
    url: goodPick + 'get',
    method: 'post',
    params
  })
}

/*
* 更新专集概要信息
* frontId  前端id
* platformDict  平台
* shareTitle  分享标题
* sourceDict  类型
 */
export function updateSummary(params) {
  return request({
    url: goodPick + 'updateSummary',
    method: 'post',
    params
  })
}

/*
删除某个课程
 frontId  前端id
id  id
 */
export function deleteGoodPick(params) {
  return request({
    url: goodPick + 'delete',
    method: 'post',
    params
  })
}

/*
批量添加课程create
 */
export function batchCreateGoodPick(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: goodPick + 'create',
    method: 'post',
    transformRequest: [function(data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}

/*
修改
 */
export function updateGoodPick(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: goodPick + 'update',
    method: 'post',
    transformRequest: [function(data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}

/*
/!* 清除所有商品
*  frontId  前端id
* *!/
export function clearGoodPick(params) {
  return request({
    url: goodPick + 'clear',
    method: 'post',
    params
  })
}

/!* 更新商品
* *!/
export function updateGoodPick(params) {
  return request({
    url: goodPick + 'update',
    method: 'post',
    params
  })
}
*/
